import React from 'react';
import '../styles/ElementDisplay.css';
import '../styles/animations.css';
import categoriesData from '../data/categories.json';

const ElementDisplay = ({ type, category, color, size = 200 }) => {
  // Helper function to get element data from categories.json
  const getElementData = () => {
    const categoryData = categoriesData.categories.find(cat => cat.id === category + 's');
    if (!categoryData) return null;
    
    const elementData = categoryData.elements.find(elem => elem.id === type);
    return elementData;
  };
  
  // Helper function to get emoji for animals, fruits, vegetables, and body parts
  const getEmoji = () => {
    const elementData = getElementData();
    if (elementData && elementData.emoji) {
      return elementData.emoji;
    }
    return '❓';
  };

  // Render different types of elements
  const renderElement = () => {
    // For shapes
    if (category === 'shape') {
      switch (type) {
        case 'circle':
          return (
            <div 
              className="element circle" 
              style={{ 
                backgroundColor: color,
                width: size,
                height: size,
                borderRadius: '50%'
              }}
            />
          );
        case 'square':
          return (
            <div 
              className="element square" 
              style={{ 
                backgroundColor: color,
                width: size,
                height: size
              }}
            />
          );
        case 'triangle':
          return (
            <div className="element-container" style={{ width: size, height: size }}>
              <div 
                className="element triangle" 
                style={{ 
                  borderBottomColor: color,
                  borderLeftWidth: size / 2,
                  borderRightWidth: size / 2,
                  borderBottomWidth: size
                }}
              />
            </div>
          );
        case 'star':
          return (
            <div className="element-container" style={{ width: size, height: size }}>
              <div 
                className="element star" 
                style={{ 
                  color: color
                }}
              >★</div>
            </div>
          );
        case 'heart':
          return (
            <div className="element-container" style={{ width: size, height: size }}>
              <div 
                className="element heart" 
                style={{ 
                  color: color
                }}
              >❤️</div>
            </div>
          );
        case 'rectangle':
          return (
            <div 
              className="element rectangle" 
              style={{ 
                backgroundColor: color,
                width: size,
                height: size * 0.6
              }}
            />
          );
        case 'oval':
          return (
            <div 
              className="element oval" 
              style={{ 
                backgroundColor: color,
                width: size * 1.5,  // Make it wider than it is tall
                height: size,
                borderRadius: '50%'  // This creates the oval shape
              }}
            />
          );
        case 'pentagon':
          return (
            <div 
              className="element pentagon" 
              style={{ 
                backgroundColor: color,
                width: size,
                height: size,
                clipPath: 'polygon(50% 0%, 100% 38%, 82% 100%, 18% 100%, 0% 38%)'
              }}
            />
          );
        case 'hexagon':
          return (
            <div 
              className="element hexagon" 
              style={{ 
                backgroundColor: color,
                width: size,
                height: size,
                clipPath: 'polygon(25% 0%, 75% 0%, 100% 50%, 75% 100%, 25% 100%, 0% 50%)'
              }}
            />
          );
        default:
          return (
            <div 
              className="element circle" 
              style={{ 
                backgroundColor: color,
                width: size,
                height: size,
                borderRadius: '50%'
              }}
            />
          );
      }
    } 
    // For colors
    else if (category === 'color') {
      const elementData = getElementData();
      const colorValue = elementData && elementData.value ? elementData.value : type;
      
      return (
        <div 
          className="element color-sample animate-scaleIn" 
          style={{ 
            backgroundColor: colorValue,
            width: size,
            height: size,
            borderRadius: '50%'
          }}
        />
      );
    } 
    // For animals, fruits, vegetables, body parts, or numbers
    else if (['animal', 'fruit', 'vegetable', 'body_part'].includes(category)) {
      return (
        <div className="element-container" style={{ width: size, height: size }}>
          <div className="element emoji animate-scaleIn">
            {getEmoji()}
          </div>
        </div>
      );
    }
    // For numbers
    else if (category === 'number') {
      const elementData = getElementData();
      const value = elementData && elementData.value ? elementData.value : type;
      
      return (
        <div className="element-container" style={{ width: size, height: size }}>
          <div 
            className="element number animate-scaleIn" 
            style={{ 
              fontSize: size * 0.8,
              color: color || '#333'
            }}
          >
            {value}
          </div>
        </div>
      );
    }
  };

  return (
    <div className="element-wrapper">
      {renderElement()}
    </div>
  );
};

export default ElementDisplay;
